import { useId } from "react";
import { useAppStore } from "@/lib/store";
import { toBengaliNumerals, toEnglishNumerals } from "@/lib/bdNumerals";

interface Props {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  unit?: string;
  error?: string | null;
  min?: number;
  max?: number;
  step?: number;
}

export function NumberInput({ label, value, onChange, placeholder, unit, error, min, max, step }: Props) {
  const id = useId();
  const lang = useAppStore((s) => s.lang);

  const display = lang === "bn" ? toBengaliNumerals(value) : value;

  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className={`block text-sm font-medium ${lang === "bn" ? "font-bn" : ""}`}>
        {label}
      </label>
      <div className="relative">
        <input
          id={id}
          type="text"
          inputMode="decimal"
          value={display}
          placeholder={placeholder}
          onChange={(e) => onChange(toEnglishNumerals(e.target.value))}
          min={min}
          max={max}
          step={step}
          className={`w-full rounded-lg border bg-muted px-3 py-2.5 text-base outline-none transition tabular-nums focus:bg-background focus:ring-2 ${
            error
              ? "border-destructive focus:border-destructive focus:ring-destructive/20"
              : "border-border focus:border-accent focus:ring-accent/20"
          } ${unit ? "pr-14" : ""}`}
        />
        {unit && (
          <span className={`absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground ${lang === "bn" ? "font-bn" : ""}`}>
            {unit}
          </span>
        )}
      </div>
      {error && <p className={`text-xs text-destructive ${lang === "bn" ? "font-bn" : ""}`}>{error}</p>}
    </div>
  );
}
